import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(() => ({
  formControl: {
    width: "100%"
  }
}))

export default styles
